import React from 'react';
import { Lock, XCircle } from 'lucide-react';
export function EnemySection() {
  return <section className="w-full bg-navy py-20 px-4 relative overflow-hidden" data-id="element-39" data-mp="2up2n38sty1if">
      {/* Background accent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-danger/5 blur-[120px] rounded-full pointer-events-none" data-id="element-40" data-mp="2gqb8lla22dtr" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-41" data-mp="2kszky2xza2vh">
        <div className="text-center mb-12" data-id="element-42" data-mp="26yygqto9bnnq">
          <div className="inline-flex items-center justify-center p-3 bg-danger/10 rounded-full mb-4" data-id="element-43" data-mp="26xx78tmw3984">
            <Lock className="w-8 h-8 text-danger" data-id="element-44" data-mp="1x1kdxwv9axdw" />
          </div>
          <h2 className="text-3xl md:text-4xl font-headline font-bold text-white uppercase mb-4" data-id="element-45" data-mp="1x3dlrfhlvnnh">
            Sección 2: El Enemigo{' '}
            <span className="text-danger" data-id="element-46" data-mp="1o14auoifds9k">(El Sistema "Pay-to-Play")</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-47" data-mp="1szpbgp1ladyj">
          <div className="space-y-6 text-gray-300 text-lg" data-id="element-48" data-mp="1t21r2vjvkc8f">
            <p data-id="element-49" data-mp="1r4zw5c1y5con">
              La mayoría de los padres hispanos cometen el mismo error:{' '}
              <span className="text-white font-semibold" data-id="element-50" data-mp="1n57l8sp2yug4">
                Creer que si el niño mete muchos goles, un scout "aparecerá
                mágicamente" en el parque público el domingo.
              </span>
            </p>

            <div className="flex items-center gap-3 text-danger font-bold text-2xl" data-id="element-51" data-mp="1w5xa1cfxbkkc">
              <XCircle className="w-8 h-8" data-id="element-52" data-mp="18g2zj1j2u839" />
              <span data-id="element-53" data-mp="13ggomyqq13xm">Eso no va a pasar.</span>
            </div>

            <p data-id="element-54" data-mp="13i9uwcxf9m53">
              Las academias élite y los clubes Premier (ECNL, MLS Next)
              funcionan como un club privado. Ellos no buscan al mejor jugador;
              buscan al jugador que ya entiende el{' '}
              <span className="text-gold" data-id="element-55" data-mp="1dctdnjbbmtm1">"lenguaje del sistema"</span>.
            </p>
          </div>

          <div className="bg-navy-light border border-white/10 p-8 rounded-xl shadow-2xl relative" data-id="element-56" data-mp="kpywav9swacs">
            <div className="absolute -top-3 -right-3 bg-danger text-white text-xs font-bold px-3 py-1 rounded uppercase tracking-wider" data-id="element-57" data-mp="2ks87uncdwkxu">
              La Realidad
            </div>
            <h3 className="text-xl font-headline font-bold text-white mb-4" data-id="element-58" data-mp="2pp6y2usxg7qr">
              Lo que el Scout realmente mira:
            </h3>
            <p className="text-gray-400 mb-6" data-id="element-59" data-mp="2yk4tq9nglyls">
              Mientras tú te enfocas en que tu hijo haga "jugaditas de YouTube",
              el scout está evaluando 5 métricas que no tienen nada que ver con
              el balón... y que nadie te ha dicho.
            </p>
            <div className="space-y-3" data-id="element-60" data-mp="2au0sua1nocyh">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="h-2 bg-navy rounded-full overflow-hidden" data-id="element-61" data-mp="2aw53rbxz2c89">
                  <div className="h-full bg-gradient-to-r from-danger to-orange-500 w-3/4 opacity-50" data-id="element-62" data-mp="3m9pgz4qnbi0v" />
                </div>)}
            </div>
            <p className="text-center text-xs text-muted mt-4 uppercase tracking-widest" data-id="element-63" data-mp="3radgkesxx76p">
              Datos ocultos para los padres
            </p>
          </div>
        </div>
      </div>
    </section>;
}